module.exports = __webpack_public_path__ + "img/NC.ac1fe8cf.svg";